import { c as _c } from "react/compiler-runtime";
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useContext, useEffect } from 'react';
import { FeatureFlagControlPanelContext } from '../providers/feature-flag-control-panel';

/**
 * Load the value of a single feature flag, providing a fallback value. The key should match the
 * name of the flag in LaunchDarkly exactly if `useCamelCaseFlagKeys` is set to false, otherwise it
 * should be the camelcase version of the key.
 */
export function useFeatureFlag(key, fallbackValue, accountUuid) {
  const $ = _c(11);
  const client = useLDClient();
  const {
    addFlagEvaluation,
    removeFlagEvaluation
  } = useContext(FeatureFlagControlPanelContext);
  let t0;
  let t1;
  if ($[0] !== addFlagEvaluation || $[1] !== key || $[2] !== removeFlagEvaluation) {
    t0 = () => {
      addFlagEvaluation(key);
      return () => {
        removeFlagEvaluation(key);
      };
    };
    t1 = [addFlagEvaluation, key, removeFlagEvaluation];
    $[0] = addFlagEvaluation;
    $[1] = key;
    $[2] = removeFlagEvaluation;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (!client) {
    return false as T;
  }
  let flagValue;
  let t2;
  if ($[5] !== accountUuid || $[6] !== client || $[7] !== fallbackValue || $[8] !== key) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      flagValue = client.variation(key, fallbackValue);
      if (flagValue.accountUuids && Array.isArray(flagValue.accountUuids)) {
        if (!accountUuid) {
          t2 = fallbackValue;
          break bb0;
        }
        t2 = flagValue.accountUuids.includes(accountUuid) || flagValue.accountUuids.includes("ALL") ? true as T : fallbackValue;
        break bb0;
      }
    }
    $[5] = accountUuid;
    $[6] = client;
    $[7] = fallbackValue;
    $[8] = key;
    $[9] = flagValue;
    $[10] = t2;
  } else {
    flagValue = $[9];
    t2 = $[10];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return flagValue;
}